export default __webpack_public_path__ + "static/media/icon-featured-voucher.04eb9b90.svg";